import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const s = {
  page: { minHeight:'100vh', background:'var(--paper)', display:'flex', alignItems:'center', justifyContent:'center', padding:24 },
  card: { background:'var(--card)', border:'1px solid var(--line-card)', borderRadius:0, width:'100%', maxWidth:420, overflow:'hidden' },
  header: { background:'var(--ink)', padding:'28px 32px' },
  brand: { fontFamily:'var(--font-display)', color:'var(--paper)', fontSize:20, marginBottom:4 },
  brandSub: { color:'var(--muted-2)', fontSize:12, fontFamily:'var(--font-mono)', letterSpacing:'1px' },
  body: { padding:'32px' },
  title: { fontFamily:'var(--font-display)', fontSize:20, fontWeight:700, marginBottom:6, color:'var(--ink)' },
  sub: { color:'var(--muted)', fontSize:13, marginBottom:28 },
  group: { marginBottom:18 },
  label: { display:'block', fontSize:11, fontFamily:'var(--font-mono)', letterSpacing:'1px', marginBottom:6, textTransform:'uppercase', color:'var(--muted-2)' },
  input: { width:'100%', padding:'11px 14px', border:'1px solid var(--line)', borderRadius:0, fontSize:14, outline:'none', transition:'border-color 0.15s', fontFamily:'var(--font-body)', background:'var(--card)' },
  btn: { width:'100%', background:'var(--ink)', color:'var(--paper)', border:'none', padding:'13px', fontSize:15, fontWeight:600, borderRadius:0, cursor:'pointer', marginTop:4, letterSpacing:'0.3px' },
  forgot: { display:'block', textAlign:'right', fontSize:12, color:'var(--muted)', marginTop:6, cursor:'pointer' },
  footer: { textAlign:'center', marginTop:20, fontSize:13, color:'var(--muted)' },
  link: { color:'var(--ink)', fontWeight:600 },
  error: { background:'var(--card)', border:'1px solid var(--danger)', color:'var(--danger)', padding:'10px 14px', borderRadius:0, fontSize:13, marginBottom:16 }
};

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post('/api/auth/login', form);
      login(data.token, data.user);
      navigate('/');
    } catch (err) {
      const d = err.response?.data;
      if (d?.needsVerification) {
        navigate('/verify-email', { state: { userId: d.userId } });
      } else {
        setError(d?.message || 'Login failed');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card} className="fade-in">
        <div style={s.header}>
          <div style={s.brand}>BioMedArticles</div>
          <div style={s.brandSub}>Clinical Research Platform</div>
        </div>
        <div style={s.body}>
          <h2 style={s.title}>Sign in</h2>
          <p style={s.sub}>Access the clinical trials database</p>
          {error && <div style={s.error}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <div style={s.group}>
              <label style={s.label}>Email</label>
              <input style={s.input} type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="you@institution.edu" required onFocus={e => e.target.style.borderColor='var(--ink)'} onBlur={e => e.target.style.borderColor='var(--line)'} />
            </div>
            <div style={s.group}>
              <label style={s.label}>Password</label>
              <input style={s.input} type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="••••••••" required onFocus={e => e.target.style.borderColor='var(--ink)'} onBlur={e => e.target.style.borderColor='var(--line)'} />
              <Link to="/forgot-password" style={s.forgot}>Forgot password?</Link>
            </div>
            <button style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} type="submit" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign in →'}
            </button>
          </form>
          <div style={s.footer}>
            Don't have an account? <Link to="/register" style={s.link}>Create one</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
